import React from 'react';

interface VistaCalcLogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const VistaCalcLogo: React.FC<VistaCalcLogoProps> = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-4xl'
  };

  const logoSize = size === 'sm' ? 'w-8 h-8' : size === 'md' ? 'w-12 h-12' : 'w-16 h-16';

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Official VistaCalc Logo */}
      <div className="relative">
        <img 
          src="/vistacalc-logo.png" 
          alt="VistaCalc Logo"
          className={`${logoSize} object-contain`}
        />
      </div>
      
      {/* Text */}
      <div className="flex flex-col">
        <div className={`font-bold ${sizeClasses[size]} leading-tight`}>
          <span className="text-vista-silver-800">Vista</span>
          <span className="text-vista-teal-500">Calc</span>
        </div>
        <div className={`text-xs ${size === 'sm' ? 'text-xs' : size === 'md' ? 'text-xs' : 'text-sm'} text-vista-silver-600 ml-1`}>
          <span className="text-vista-silver-500">by</span>{' '}
          <span className="text-vista-teal-500 font-medium">VistaValue</span>
        </div>
      </div>
    </div>
  );
};

export default VistaCalcLogo;
